/**
 * MÉMOIRE DE DÉFILEMENT (30/09/2026).
 *
 * Lucas, dans l'espace association : « quand je reviens en arrière, je reviens
 * tout en haut de mon espace association, c'est chiant ». Deux causes :
 *  - App.js remontait en haut à CHAQUE changement de page, retour compris :
 *    revenir de la FAQ, du blog ou de la page publique perdait la position ;
 *  - dans l'espace association, les rubriques sont des onglets d'une même
 *    page : revenir à l'accueil de l'espace ré-affichait le menu depuis le
 *    haut, sans mémoire de là où l'on était.
 *
 * Ce module garde, par entrée d'historique (clé React Router), la dernière
 * position connue, et sait la restaurer quand le contenu est assez haut pour
 * l'atteindre (les données arrivent souvent après le premier rendu).
 */
const CLE = "gively:defilement";
const MAX_ENTREES = 60;

function lire() {
  try {
    return JSON.parse(sessionStorage.getItem(CLE) || "{}") || {};
  } catch {
    return {};
  }
}

export function memoriserPosition(cle, y) {
  if (!cle) return;
  try {
    const carte = lire();
    delete carte[cle];
    carte[cle] = Math.max(0, Math.round(y));
    const cles = Object.keys(carte);
    for (let i = 0; i < cles.length - MAX_ENTREES; i += 1) delete carte[cles[i]];
    sessionStorage.setItem(CLE, JSON.stringify(carte));
  } catch {
    /* stockage indisponible (navigation privée) : on ne mémorise pas */
  }
}

export function positionMemorisee(cle) {
  const y = lire()[cle];
  return typeof y === "number" ? y : null;
}

/**
 * Ramène la page à `y` dès que le contenu le permet (au plus ~2 s). S'arrête
 * si l'utilisateur fait défiler lui-même entre-temps : on ne lui arrache
 * jamais la page des mains.
 */
export function restaurerPosition(y, { delaiMax = 2000 } = {}) {
  if (typeof window === "undefined" || y == null) return () => {};
  let fini = false;
  const stop = () => { fini = true; };
  const evenements = ["wheel", "touchstart", "keydown"];
  evenements.forEach((e) => window.addEventListener(e, stop, { passive: true, once: true }));
  const debut = Date.now();
  const essayer = () => {
    if (fini) return;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    if (max >= y - 2 || Date.now() - debut > delaiMax) {
      window.scrollTo(0, Math.min(y, Math.max(0, max)));
      fini = true;
      return;
    }
    setTimeout(essayer, 50);
  };
  essayer();
  return () => {
    fini = true;
    evenements.forEach((e) => window.removeEventListener(e, stop));
  };
}
